import { waitForOpenCV } from './opencv-js/index.js';

class OpenCVService {
    isReady = false;
    cv = null;
    readyCallbacks = [];
    constructor() {
        waitForOpenCV().then(cv => {
            this.cv = cv;
            this.isReady = true;
            this.readyCallbacks.forEach(callback => callback(this.cv));
            this.readyCallbacks = [];
        });
    }

    waitReady() {
        return new Promise((resolve, reject) => {
            this.readyCallbacks.push(async () => {
                await this.applyFilters(imagePath, filters);
                resolve(null);
            });
        });
    }

    async applyFilters(imagePath, filters) {
        if (!this.isReady) {
            return this.waitReady();
        }
        return new Promise((resolve, reject) => {
            try {
                // Créer un élément image temporaire pour charger l'image
                const img = new Image();
                img.crossOrigin = "anonymous";
                
                img.onload = async () => {
                    try {
                        // Créer un canvas pour dessiner l'image
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        
                        // Obtenir les données de l'image
                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        
                        // Créer une Mat OpenCV
                        let cvImage = this.cv.matFromImageData(imageData);
                        // Appliquer les filtres
                        for (const filter of filters) {
                            cvImage = await filter.filterAction(this.cv, cvImage);
                        }
                        
                        // Convertir en base64
                        const processedCanvas = document.createElement('canvas');
                        this.cv.imshow(processedCanvas, cvImage);
                        const dataURL = processedCanvas.toDataURL('image/png');
                        
                        // Nettoyer la mémoire
                        cvImage.delete();

                        resolve(dataURL);
                    } catch (error) {
                        reject(error);
                    }
                };
                
                img.onerror = () => {
                    reject(new Error("Impossible de charger l'image"));
                };
                img.src = imagePath;
            } catch (error) {
                reject(error);
            }
        });
    }
}

// Instance singleton
const opencvService = new OpenCVService();

export default opencvService; 